/**
 * Shared edit→view / view-clears-edit rules used by server resolve and client previews.
 * Keep in sync with docs/user-rights-and-roles.md.
 */
export function applyCapabilityImplications(
  caps: Record<string, boolean>,
): Record<string, boolean> {
  if (caps["web.projekte.edit"]) caps["web.projekte.view"] = true;
  if (caps["web.rechnungen.edit"]) caps["web.rechnungen.view"] = true;
  if (caps["web.rechnungen.approve"]) caps["web.rechnungen.view"] = true;
  if (caps["web.rechnungen.datev"]) caps["web.rechnungen.view"] = true;
  if (caps["web.kontakte.edit"]) caps["web.kontakte.view"] = true;
  if (caps["web.plantafel.edit"]) caps["web.plantafel.view"] = true;
  if (caps["web.aufgaben.edit"]) caps["web.aufgaben.view"] = true;
  if (caps["web.aufgaben.view"]) caps["web.aufgaben.own"] = true;
  if (caps["web.posteingang.edit"]) caps["web.posteingang.view"] = true;
  if (caps["web.stammdaten.edit"]) caps["web.stammdaten.view"] = true;
  if (caps["web.ausschreibungen.edit"]) caps["web.ausschreibungen.view"] = true;
  if (caps["web.vorlagen.edit"]) caps["web.vorlagen.view"] = true;
  if (caps["web.fuhrpark.edit"]) caps["web.fuhrpark.view"] = true;
  if (caps["web.hr.edit"]) caps["web.hr.view"] = true;
  if (caps["web.hr.approve"]) caps["web.hr.view"] = true;
  if (caps["web.hr.internal"]) caps["web.hr.view"] = true;
  if (caps["web.einstellungen.edit"]) caps["web.einstellungen.view"] = true;
  if (caps["web.einstellungen.invite"]) caps["web.einstellungen.view"] = true;
  if (caps["app.zeit.geofence_in"] || caps["app.zeit.geofence_out"]) caps["app.zeit.edit"] = true;
  if (caps["app.zeit.edit"]) caps["app.zeit.view"] = true;
  if (caps["app.kalender.edit"]) caps["app.kalender.view"] = true;
  if (caps["app.kalender.update"]) caps["app.kalender.view"] = true;
  if (caps["app.kommentare.edit"]) caps["app.kommentare.view"] = true;
  if (caps["app.kalender.team_view"]) caps["app.kalender.view"] = true;
  if (caps["app.zeit.team_edit"]) caps["app.zeit.view"] = true;

  if (!caps["web.projekte.view"]) caps["web.projekte.edit"] = false;
  if (!caps["web.rechnungen.view"]) {
    caps["web.rechnungen.edit"] = false;
    caps["web.rechnungen.approve"] = false;
    caps["web.rechnungen.datev"] = false;
  }
  if (!caps["web.kontakte.view"]) caps["web.kontakte.edit"] = false;
  if (!caps["web.plantafel.view"]) caps["web.plantafel.edit"] = false;
  if (!caps["web.aufgaben.own"]) caps["web.aufgaben.view"] = false;
  if (!caps["web.aufgaben.view"]) caps["web.aufgaben.edit"] = false;
  if (!caps["web.posteingang.view"]) caps["web.posteingang.edit"] = false;
  if (!caps["web.stammdaten.view"]) caps["web.stammdaten.edit"] = false;
  if (!caps["web.ausschreibungen.view"]) caps["web.ausschreibungen.edit"] = false;
  if (!caps["web.vorlagen.view"]) caps["web.vorlagen.edit"] = false;
  if (!caps["web.fuhrpark.view"]) caps["web.fuhrpark.edit"] = false;
  if (!caps["web.hr.view"]) {
    caps["web.hr.edit"] = false;
    caps["web.hr.approve"] = false;
    caps["web.hr.internal"] = false;
  }
  if (!caps["web.einstellungen.view"]) {
    caps["web.einstellungen.edit"] = false;
    caps["web.einstellungen.invite"] = false;
  }
  if (!caps["app.zeit.view"]) caps["app.zeit.edit"] = false;
  if (!caps["app.zeit.edit"]) {
    caps["app.zeit.geofence_in"] = false;
    caps["app.zeit.geofence_out"] = false;
  }
  if (!caps["app.kalender.view"]) {
    caps["app.kalender.edit"] = false;
    caps["app.kalender.update"] = false;
    caps["app.kalender.team_view"] = false;
  }
  if (!caps["app.zeit.view"]) caps["app.zeit.team_edit"] = false;
  if (!caps["app.kommentare.view"]) caps["app.kommentare.edit"] = false;
  return caps;
}
